import {IconProps} from './types'

export default function SunnyIcon({size = 16, ...props}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clip-path="url(#clip0_5_29775)">
        <path
          d="M8 10.6667C9.47276 10.6667 10.6667 9.4728 10.6667 8.00004C10.6667 6.52728 9.47276 5.33337 8 5.33337C6.52724 5.33337 5.33333 6.52728 5.33333 8.00004C5.33333 9.4728 6.52724 10.6667 8 10.6667Z"
          stroke="#F8971D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 1.33337V2.66671"
          stroke="#F8971D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 13.3334V14.6667"
          stroke="#F8971D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.28667 3.28662L4.22667 4.22662"
          stroke="#F8971D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.7733 11.7733L12.7133 12.7133"
          stroke="#F8971D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.33333 8H2.66667"
          stroke="#F8971D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.3333 8H14.6667"
          stroke="#F8971D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.22667 11.7733L3.28667 12.7133"
          stroke="#F8971D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.7133 3.28662L11.7733 4.22662"
          stroke="#F8971D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_29775">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
